
import page from "~/layouts/testimonial.vue";

export default {
  components: {
    page,
  },

  head() {
    return {
      title: "Création de logo pour boutique de prêt à porter | Agence ALEO",
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            "Le Repère nous a confié la mission de repenser son identité visuelle, comprenant la création d'un tout nouveau logo ainsi que la conception de cartes de visite !",
        },
        {
          hid: "og:title",
          property: "og:title",
          content: "Graphisme",
        },
        {
          hid: "og:description",
          property: "og:description",
          content: "Le Repère",
        },
      ],
    };
  },
};
